import { useClientsQuery } from './queries';

export type PhoneDuplicateValidator = (
  value: unknown,
  formValues: { phonePrefix?: string | null },
) => Promise<string | true>;

export const usePhoneDuplicateValidator = (currentClientId?: string): PhoneDuplicateValidator => {
  const { data: clients = [] } = useClientsQuery();

  return async (value: unknown, formValues: { phonePrefix?: string | null }) => {
    const str = typeof value === 'string' ? value : undefined;
    if (!str) return true;

    const prefix = formValues?.phonePrefix ?? null;
    const duplicate = clients.find(
      client =>
        client.phone === str &&
        (client.phonePrefix ?? null) === prefix &&
        client.id !== currentClientId,
    );

    return duplicate ? 'client.phoneAlreadyExists' : true;
  };
};
